import { h, reactive, readonly, ref } from 'vue';

import { DialogProps } from '../../components/Dialog/Dialog.vue';
import Deferred from '../../utils/Deferred';

export interface Result {
  isConfirmed?: boolean;
  isCanceled?: boolean;
}

export interface ActiveDialog extends DialogProps {
  deferred?: Deferred<Result>;
  onConfirm?: () => void;
  onCancel?: () => void;
  slots?: Record<string, typeof h>;
}

const active = ref<ActiveDialog>();

export default function useDialog() {
  function open(dialog: Omit<ActiveDialog, 'deferred'>) {
    if (active.value) {
      throw new Error('A Dialog is already being displayed');
    }

    active.value = {
      ...dialog,
      deferred: new Deferred(),
    };

    return active.value.deferred?.promise;
  }

  function close() {
    active.value = undefined;
  }

  return reactive({
    /**
     * The currently open dialog information.
     */
    active: readonly(active),

    /**
     * Opens the dialog.
     */
    open,

    /**
     * Closes the dialog.
     */
    close,
  });
}
